import { Link, useRouteError } from "react-router-dom";
import { ArrowIcon } from "../../components/motion";

export default function Error() {
    const error = useRouteError();
    if (error) {
        console.error(error);
    }

    return (
        <div className="container-site flex min-h-[60vh] flex-col items-start justify-center py-[96px]">
            <p className="t-eyebrow">404</p>
            <h1 className="t-display mt-4 max-w-[800px]">Bu sayfa bulunamadı.</h1>
            <p className="t-intro mt-6 font-normal text-ink-600">Taşınmış ya da bağlantı eskimiş olabilir.</p>
            <div className="mt-10 flex flex-wrap items-center gap-x-10 gap-y-4">
                <Link to="/" className="btn-pill">Ana sayfaya dön</Link>
                <Link to="/projeler" className="link-arrow"><span className="label">Projelere bak</span><ArrowIcon className="arrow" /></Link>
            </div>
        </div>
    );
}
